import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {HelperService} from '../../helpers';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  public resetForm = new FormGroup({
    password: new FormControl('', Validators.required),
    password2: new FormControl('', Validators.required)
  });

  public formError = null;
  public formSuccess = false;
  public formProcessing = false;

  constructor(
    private http: HttpClient,
    private helper: HelperService,
  ) { }

  ngOnInit() {
  }

  reset(form) {
    this.formError = null;
    this.formSuccess = false;

    if (form.controls.password.value !== form.controls.password2.value) {
      this.formError = 'Gesli se ne ujemata';
      return;
    }

    if (form.invalid) {
      this.formError = 'Vnesite novo geslo';
      return;
    }

    this.formProcessing = true;
    this.http.post(this.helper.getResetUrl() + '/change', {
      password: form.controls.password.value,
    }).subscribe((response: any) => {
      this.formProcessing = false;
      if (response.success === false) {
        switch (response.data.error) {
          case 'User missing':
            this.formError = 'Uporabnik ne obstaja';
            break;
          case 'Invalid password':
            this.formError = 'Geslo ni ustrezno';
            break;
          case 'Password to short':
            this.formError = 'Geslo je prekratko';
            break;
          default:
            this.formError = 'Napaka pri ponastavitvi gesla';
            break;
        }
      } else {
        this.formSuccess = true;
      }
    }, (error) => {
      this.formProcessing = false;
      this.formSuccess = false;
      this.formError = 'Napaka pri ponastavitvi gesla';
    });
  }

}
